/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Liu ShuaiBo
 * @Date: 2021-10-26 15:09:29
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-14 15:34:41
 */
import ColumnTypes from '@/utils/ColumnTypes';
import auth from '@/plugins/auth';
const shopDetails = {
	key: 'shopDetails',
	label: '商品信息',
	type: ColumnTypes.MixinCell,
	fixed: 'left',
	minWidth: '300',
	isShow: true,
};
const contact_user_type_desc = {
	key: 'contact_user_type_desc',
	label: '推广者信息',
	type: ColumnTypes.TextCell,
	minWidth: '130',
	isShow: true,
};
const commission_rate = {
	key: 'commission_rate',
	label: '佣金率',
	type: ColumnTypes.TextCell,
	sortable: 'commission_rate',
	minWidth: '100',
	isShow: true,
};
const normal_commission_rate = {
	key: 'normal_commission_rate',
	label: '普通佣金率',
	type: ColumnTypes.TextCell,
	sortable: 'normal_commission_rate',
	minWidth: '120',
	isShow: true,
	transform: row => {
		return {
			...row,
			normal_commission_rate: row.normal_commission_rate == -1 ? '-' : `${row.normal_commission_rate}%`,
		};
	},
};
const live_price = {
	key: 'live_price',
	label: '直播价',
	type: ColumnTypes.TextCell,
	minWidth: '100',
	isShow: true,
};
const sale_price = {
	key: 'sale_price',
	label: '现售价',
	type: ColumnTypes.TextCell,
	minWidth: '100',
	isShow: true,
};
const service_rate = {
	key: 'service_rate',
	label: '服务费率',
	type: ColumnTypes.serviceRateCell,
	sortable: 'service_rate',
	minWidth: '120',
	isShow: auth.hasPermi('system:goods-ServiceRate'),
};
const assigned_service_rate = {
	key: 'assigned_service_rate',
	label: '可分配服务费',
	type: ColumnTypes.TextCell,
	sortable: 'assigned_service_rate',
	minWidth: '130',
	isShow: true,
};
const sales = {
	key: 'sales',
	label: '30天销量',
	type: ColumnTypes.TextCell,
	minWidth: '120',
	sortable: 'sales',
	isShow: true,
};
const todoPromote = {
	key: 'todoPromote',
	label: '推广信息',
	type: ColumnTypes.promotionCell,
	minWidth: '160',
	isShow: true,
};
const todoSource = {
	key: 'todoSource',
	label: '来源',
	type: ColumnTypes.sourceCell,
	minWidth: '200',
	isShow: true,
};
const activity = {
	key: 'activity',
	label: '活动信息',
	type: ColumnTypes.activityCell,
	minWidth: '270',
	showTag: true,
	isShow: true,
};
const auditStatus = {
	key: 'audit_status',
	label: '报名状态',
	type: ColumnTypes.auditStatusCell,
	minWidth: '150',
	showTag: true,
	fixed: 'right',
	isShow: true,
	className: 'audit-status',
};
const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	minWidth: '100',
	fixed: 'right',
	align: 'right',
	isShow: true,
};
const lastMonthSales = {
	key: 'sales',
	label: '30天销量',
	type: ColumnTypes.TextCell,
	minWidth: '120',
	isShow: true,
};
const authorNum = {
	key: 'author_num',
	label: '推广达人数',
	type: ColumnTypes.TextCell,
	minWidth: '120',
	isShow: true,
	transform: row => {
		return {
			...row,
			author_num: row.product_sales?.author_num || 0,
		};
	},
};
//快手
export const ksColumns = [
	{ ...shopDetails, showProductType: true },
	contact_user_type_desc,
	sale_price,
	live_price,
	commission_rate,
	service_rate,
	sales,
	todoPromote,
	todoSource,
	activity,
	auditStatus,
	operations,
];

//抖音
export const dyColumns = [
	{ ...shopDetails, showProductType: true },
	sale_price,
	live_price,
	commission_rate,
	normal_commission_rate,
	service_rate,
	lastMonthSales,
	todoPromote,
	todoSource,
	activity,
	authorNum,
	auditStatus,
	operations,
];
//视频号
export const spColumns = [
	{ ...shopDetails, showProductType: true, commissionType: true },
	sale_price,
	live_price,
	commission_rate,
	normal_commission_rate,
	service_rate,
	assigned_service_rate,
	sales,
	todoPromote,
	todoSource,
	activity,
	auditStatus,
	operations,
];
